import request from '@/utils/request'


// 查询银行列表
export function listBank(query) {
  return request({
    url: '/biz/admin/merchant/bank/list',
    method: 'get',
    params: query
  })
}
